module.exports = __webpack_public_path__ + "static/media/bgDefaultCoursesMobileNight.27afcb8e.jpg";